import { createContext } from 'react';

const ticketsContext = createContext();

export default ticketsContext;
